/**
 * Created by charanjeetelectrovese@gmail.com on system AakritiS. on 03/04/18.
 */

import axios from "axios";
import Constants, { shouldSuppressAdminLeadSseEvent } from "../config/constants";
import store from "../store";
import { actionLogoutUser } from "../actions/Auth.action";
import EventEmitter from "./Events.utils";

export async function postRequest(url, params, baseURL = Constants.DEFAULT_APP_URL) {
  try {
    const tempRequest = await axios.post(`${baseURL}${url}`, {
      ...params,
    });
    if (tempRequest.status === 200) {
  
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
          response_code: tempRequest.data.response_code,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
        response_code: tempRequest.data.response_code,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      store.dispatch(actionLogoutUser());
      return { error: true, authorization: false, response_code: 0 };
    }
    const serverMessage = err?.response?.data?.response_message;
    return {
      error: true,
      message: serverMessage || (Constants.API_ERROR_OBJ[err?.response?.status] ? `${Constants.API_ERROR_OBJ[err.response.status]}` : "Something Went Wrong"),
      authorization: true,
    };
  }
}

export async function getRequest(url, params,apiurl) {
  try {
    const tempRequest = await axios.get(`${apiurl ? apiurl : Constants.DEFAULT_APP_URL}${url}`, {
      params: { ...params },
    });
    if (tempRequest.status === 200) {
    
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      return { error: true, authorization: false };
    }
    const serverMessage = err?.response?.data?.response_message;
    return {
      error: true,
      message: serverMessage || (Constants.API_ERROR_OBJ[err?.response?.status] ? `${Constants.API_ERROR_OBJ[err.response.status]}` : "Something Went Wrong"),
      authorization: true,
    };
  }
}

export async function putRequest(url, params, baseURL = Constants.DEFAULT_APP_URL) {
  try {
    const tempRequest = await axios.put(`${baseURL}${url}`, { ...params });
    if (tempRequest.status === 200) {
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
          response_code: tempRequest.data.response_code,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
        response_code: tempRequest.data.response_code,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      store.dispatch(actionLogoutUser());
      return { error: true, authorization: false, response_code: 0 };
    }
    const serverMessage = err?.response?.data?.response_message;
    return {
      error: true,
      message:
        serverMessage ||
        (Constants.API_ERROR_OBJ[err?.response?.status]
          ? `${Constants.API_ERROR_OBJ[err.response.status]}`
          : "Something Went Wrong"),
      authorization: true,
    };
  }
}

export async function deleteRequest(url, baseURL = Constants.DEFAULT_APP_URL) {
  try {
    const tempRequest = await axios.delete(`${baseURL}${url}`);
    if (tempRequest.status === 200) {
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
          response_code: tempRequest.data.response_code,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
        response_code: tempRequest.data.response_code,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      store.dispatch(actionLogoutUser());
      return { error: true, authorization: false, response_code: 0 };
    }
    const serverMessage = err?.response?.data?.response_message;
    return {
      error: true,
      message:
        serverMessage ||
        (Constants.API_ERROR_OBJ[err?.response?.status]
          ? `${Constants.API_ERROR_OBJ[err.response.status]}`
          : "Something Went Wrong"),
      authorization: true,
    };
  }
}

// export function getRequestSSE(url, params = {}, apiurl, onMessage, onError, token) {
//   const fullUrl = new URL(`${apiurl ? apiurl : Constants.DEFAULT_APP_URL}${url}`);


//   Object.keys(params || {}).forEach((key) => {
//     fullUrl.searchParams.append(key, params[key]);
//   });

//   let controller = new AbortController();
//   const { signal } = controller;

//   const connect = async () => {
//     try {
//       const response = await fetch(fullUrl, {
//         method: "GET",
//         headers: {
//           "Accept": "text/event-stream",
//           "Cache-Control": "no-cache",
//           "Authorization": `${token}`,
//         },
//         signal,
//       });

//       if (!response.ok) {
//         throw new Error(`SSE connection failed: ${response.status}`);
//       }

//       const reader = response.body.getReader();
//       const decoder = new TextDecoder("utf-8");

//       let buffer = "";

//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;

//         buffer += decoder.decode(value, { stream: true });


//         const parts = buffer.split("\n\n");
//         buffer = parts.pop(); 

//         for (const part of parts) {
//           if (part.startsWith("data: ")) {
//             try {
//               const parsed = JSON.parse(part.substring(6));
//               if (onMessage) onMessage(parsed);
//                EventEmitter.dispatch("SSE_EVENT", parsed);
//             } catch (err) {
//               console.error("Failed to parse SSE chunk:", err);
//             }
//           }
//         }
//       }
//     } catch (err) {
//       // console.error("SSE error:", err);
//       if (onError) onError(err);

      
//       setTimeout(connect, 5000);
//     }
//   };

//   connect();


//   return {
//     close: () => {
//       controller.abort();
//     },
//   };
// }
export function getRequestSSE(url, params = {}, apiurl, onMessage, onError, token) {
  const fullUrl = new URL(`${apiurl ? apiurl : Constants.DEFAULT_APP_URL}${url}`);
  Object.keys(params || {}).forEach((key) => {
    fullUrl.searchParams.append(key, params[key]);
  });

  let controller = new AbortController();
  const { signal } = controller;

  const connect = async () => {
    try {
      const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
          "Cache-Control": "no-cache",
          Authorization: `${token}`,
        },
        signal,
      });

      if (!response.ok) throw new Error(`SSE connection failed: ${response.status}`);

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split("\n\n");
        buffer = events.pop();

        for (const event of events) {
          const lines = event.split("\n").filter(Boolean);
          let parsedEvent = { event: "message", data: "" };

          for (const line of lines) {
            if (line.startsWith("event:")) {
              parsedEvent.event = line.replace("event:", "").trim();
            } else if (line.startsWith("data:")) {
              parsedEvent.data += line.replace("data:", "").trim();
            }
          }

          try {
            const parsedData = JSON.parse(parsedEvent.data);
            if (onMessage) onMessage(parsedData);
            if (!shouldSuppressAdminLeadSseEvent(parsedData)) {
              EventEmitter.dispatch("SSE_EVENT", parsedData);
            }
          } catch (err) {
            console.error("Failed to parse SSE data:", err);
          }
        }
      }
    } catch (err) {
      if (onError) onError(err);
      setTimeout(connect, 5000);
    }
  };

  connect();

  return {
    close: () => controller.abort(),
  };
}

export async function formDataRequest(url, formData) {
 
  try {
    const tempRequest = await axios({
      method: "post",
      url: `${Constants.DEFAULT_APP_URL}${url}`,
      data: formData,
    });
    if (tempRequest.status === 200) {
    
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      return { error: true, authorization: false };
    }
    const serverMessage = err?.response?.data?.response_message;
    return {
      error: true,
      message: serverMessage || (Constants.API_ERROR_OBJ[err?.response?.status] ? `${Constants.API_ERROR_OBJ[err.response.status]}` : "Something Went Wrong"),
      authorization: true,
    };
  }
}
